/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';
import dates from './utils/dates';
import { navigate } from './utils/constants';
import TimeGrid from './TimeGrid';

class Week extends React.Component {
    static propTypes = {
        date: PropTypes.instanceOf(Date).isRequired,
    };

    static defaultProps = TimeGrid.defaultProps;

    render() {
        const { date, ...props } = this.props;
        const range = Week.range(date, this.props);

        return <TimeGrid {...props} range={range} eventOffset={15} />;
    }
}

Week.navigate = (date, action) => {
    switch (action) {
        case navigate.PREVIOUS:
            return dates.add(date, -1, 'week');

        case navigate.NEXT:
            return dates.add(date, 1, 'week');

        default:
            return date;
    }
};

Week.range = (date, { localizer }) => {
    const firstOfWeek = localizer.startOfWeek();
    const start = dates.startOf(date, 'week', firstOfWeek);
    const end = dates.endOf(date, 'week', firstOfWeek);

    return dates.range(start, end);
};

Week.title = (date, { localizer }) => {
    const [start, ...rest] = Week.range(date, { localizer });
    return localizer.format({ start, end: rest.pop() }, 'dayRangeHeaderFormat');
};

export default Week;
